export const mapToSetters = (source, setters) => {
    for (const key of Object.keys(setters)) {
        if (source.hasOwnProperty(key)) {
            setters[key](source[key]);
        }
    }
}